import { TYPES } from "../actions/types";

const initialState = {
  registeredEtsyShops: [],
  totalCount: 0,
  currentPage: 1,
  itemsPerPage: 10,
  loading: false,
  error: null,
  selectedShop: null
};

export const tkt1RegisteredEtsyShopReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get registered etsy shops
    case TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOPS_SUCCESS:
      return {
        ...state,
        registeredEtsyShops: action.payload.data.data || [],
        totalCount: action.payload.data.pagination?.total_count || 0,
        currentPage: action.payload.data.pagination?.current_page || 1,
        itemsPerPage: action.payload.data.pagination?.limit || 10,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOPS_FAIL:
      return {
        ...state,
        registeredEtsyShops: [],
        totalCount: 0,
        loading: false,
        error: action.payload.message || 'Failed to load registered etsy shops'
      };

    // Search registered etsy shops
    case TYPES.ACTION_SEARCH_TKT1_REGISTERED_ETSY_SHOPS_SUCCESS:
      return {
        ...state,
        registeredEtsyShops: action.payload.data.data || [],
        totalCount: action.payload.data.pagination?.total_count || 0,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_SEARCH_TKT1_REGISTERED_ETSY_SHOPS_FAIL:
      return {
        ...state,
        registeredEtsyShops: [],
        totalCount: 0,
        loading: false,
        error: action.payload.message || 'Failed to search registered etsy shops'
      };

    // Get registered etsy shop by ID
    case TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_ID_SUCCESS:
      return {
        ...state,
        selectedShop: action.payload.data,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_ID_FAIL:
      return {
        ...state,
        selectedShop: null,
        loading: false,
        error: action.payload.message || 'Failed to load registered etsy shop'
      };

    // Get registered etsy shop by MID
    case TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_MID_SUCCESS:
      return {
        ...state,
        selectedShop: action.payload.data,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_MID_FAIL:
      return {
        ...state,
        selectedShop: null,
        loading: false,
        error: action.payload.message || 'Failed to load registered etsy shop by MID'
      };

    // Create registered etsy shop
    case TYPES.ACTION_CREATE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS:
      return {
        ...state,
        registeredEtsyShops: [action.payload.data, ...state.registeredEtsyShops],
        totalCount: state.totalCount + 1,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_CREATE_TKT1_REGISTERED_ETSY_SHOP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message || 'Failed to create registered etsy shop'
      };

    // Update registered etsy shop
    case TYPES.ACTION_UPDATE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS:
      return {
        ...state,
        registeredEtsyShops: state.registeredEtsyShops.map(shop => 
          shop._id === action.payload.data._id ? action.payload.data : shop
        ),
        selectedShop: action.payload.data,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_UPDATE_TKT1_REGISTERED_ETSY_SHOP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message || 'Failed to update registered etsy shop'
      };

    // Delete registered etsy shop
    case TYPES.ACTION_DELETE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS:
      return {
        ...state,
        registeredEtsyShops: state.registeredEtsyShops.filter(shop => shop._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        selectedShop: null,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_DELETE_TKT1_REGISTERED_ETSY_SHOP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message || 'Failed to delete registered etsy shop'
      };

    // API call failure
    case TYPES.ACTION_CALL_API_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message || 'API call failed'
      };

    default:
      return state;
  }
};

export default tkt1RegisteredEtsyShopReducer;
